export default function Checked() {
  return <span className="ml-2 text-gray-600">✓</span>;
}
